import React from 'react';
import {
    NumberField,
    ShowController,
    ShowView,
    Tab,
    TabbedShowLayout,
    TextField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

export const styles = {
};

const VnNodeTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>{record ? `${record.PID} ` : ''}</span>;
};

export const VnNodeShow = props => (
    <ShowController {...props}>
        {controllerProps =>
            <ShowView title={<VnNodeTitle />} {...props} {...controllerProps}>
                <TabbedShowLayout>
                    <Tab label = "Summary">
                        <TextField label="PID" source="PID" />
                        <TextField label="Description" source="Description" />
                        <NumberField
                            source="Power"
                            label={"Power [W]"}/>
                        <NumberField
                            source="Sockets"
                            label={"Sockets"}/>
                        <NumberField
                            source="Threads"
                            label={"Threads [vCPU]"}/>
                        <NumberField
                            source="BaseFrequency"
                            label={"Base Frequency [GHz]"}/>
                        <NumberField
                            source="Memory"
                            label={"Memory [GByte]"}/>
                        <NumberField
                            source="IO.1GbE"
                            label={"1 GbE ports"}/>
                        <NumberField
                            source="IO.10GbE"
                            label={"10 GbE ports"}/>
                    </Tab>
                    <Tab label = "1st screen">
                        <p>Use 'Pretested 1st screen results'</p>
                    </Tab>
                    <Tab label = "OTT / ABR">
                        <p>Use 'Test Wizard' to test your custom configurations</p>
                    </Tab>
                </TabbedShowLayout>
            </ShowView>
        }
    </ShowController>
);

export default withStyles(styles)(VnNodeShow);